import React, { useEffect, useState } from "react";
import { Card, Checkbox, Col, Row, Select, Spin, Switch } from "antd";
import {
  platformRestrictionModel,
  platforms,
  selection_dropdown,
} from "../../constants";

const { Option } = Select;
const PlatformRestriction = ({ widget, handleWidgetChange }) => {
  const [platformRestriction, setPlatformRestriction] = useState({
    ...platformRestrictionModel,
  });

  const handleSave = () => {
    handleWidgetChange({ platformRestriction, id: widget.id });
  };

  useEffect(() => {
    if (widget.platformRestriction)
      setPlatformRestriction({ ...widget.platformRestriction });
    else setPlatformRestriction({ ...platformRestrictionModel });
  }, [widget.id, widget.platformRestriction]);

  return (
    <div>
      <Spin spinning={false}>
        <Card className="setting_wrapper">
          <Row className="center_items setting_label">
            <Col span={12}>
              <h4 className="p-color">Platform Restriction</h4>
            </Col>
            <Col span={12} className="action">
              <div style={{ textAlign: "end" }} className="flex_items">
                <Switch
                  name="status"
                  id="custom-switch"
                  checked={platformRestriction.enabled}
                  onChange={(checked) => {
                    if (!checked)
                      setPlatformRestriction({ ...platformRestrictionModel });
                    else
                      setPlatformRestriction({
                        ...platformRestriction,
                        enabled: checked,
                      });
                  }}
                />
              </div>

              <div onClick={handleSave} className="action_btn ml-2">
                <i className="fa-regular fa-floppy-disk"></i>
                <span>Save</span>
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Select
                disabled={!platformRestriction.enabled}
                className="select_feld"
                placeholder="Select option"
                allowClear={false}
                value={platformRestriction.type}
                onChange={(value) => {
                  setPlatformRestriction({
                    ...platformRestriction,
                    type: value,
                  });
                }}
              >
                {selection_dropdown.map((x, i) => {
                  return (
                    <Option key={i} value={x.value}>
                      {x.label} platforms
                    </Option>
                  );
                })}
              </Select>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Checkbox.Group
                className="chc_box"
                options={platforms}
                value={platformRestriction.values}
                onChange={(value) => {
                  setPlatformRestriction({
                    ...platformRestriction,
                    values: value,
                  });
                }}
              />
            </Col>
          </Row>
          <p className="font13">
            By default, the widget will be shown to all visitors. To show or
            hide the widget for visitors from specific platforms, enable this
            functionality and specify the platforms.
          </p>
        </Card>
      </Spin>
    </div>
  );
};

export default React.memo(PlatformRestriction);
